import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import User from "./views/User.vue";
import Main from "./container/Main.vue";
import Geofence from "./views/Geofence.vue";
import Calendar from "./views/Calendar.vue";
import UserApproval from "./views/UserApproval.vue";
import Request from "./views/Request.vue";
import AssetManagement from "./views/AssetManagement.vue";
import CompanyProfile from "./views/CompanyProfile.vue";
import MyBooking from "./views/MyBooking.vue";
import BookNew from "./views/BookNew.vue";
import EmailTemplate from "./views/EmailTemplate.vue";
import UserList from "./views/UserList.vue";
import PopularAddress from "./views/PopularAddress.vue";
import Message from "./views/Message.vue";
import SwopVehicle from "./views/SwopVehicle.vue";
import Report from "./views/Report.vue";
import AssetManager from "./views/AssetManager.vue";
import AssetType from "./views/AssetType.vue";
import AssetGroup from "./views/GroupManagement.vue";
import VehicleMaintenance from "./views/VehicleMaintenance.vue";
import MyProfile from "./views/MyProfile.vue";
import ResetPassword from "./views/ResetPassword.vue";
import ReportsPage from "./reports/Page.vue";
import Company from "./views/Company.vue";
import WorkOrder from "./views/WorkOrder.vue";
import VehicleAccessories from "./views/VehicleAccessories.vue";
import Unauthorized from "./views/Unauthorized.vue";
import MyCalendar from "./views/MyCalendar.vue";
import BookV2 from "./views/BookV2.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/book",
      name: "Main",
      component: Main,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/user",
          component: User,
          name: "User",
          meta: {
            allowedRoles: [1, 3, 4],
          }
        },
        {
          path: "/user_approval",
          component: UserApproval,
          name: "User Approval",
          meta: {
            allowedRoles: [1, 3, 4],
          }
        },
        {
          path: "/geofence",
          name: "Geofence",
          meta: {
            allowedRoles: [1, 3],
          },
          component: Geofence,
        },
        {
          path: "/calendar",
          name: "Calendar",
          component: Calendar
        },
        {
          path: "/calendar_v2",
          name: "MyCalendar",
          component: MyCalendar
        },
        {
          path: "/book_v2",
          name: "Book V2",
          component: BookV2
        },
        {
          path: "/request",
          name: "Recurrence Booking Request",
          component: Request,
        },
        {
          path: "/asset_management",
          name: "Asset Management",
          component: AssetManagement,
          meta: {
            allowedRoles: [1, 3],
          }
        },
        {
          path: "/company_profile",
          name: "Company Profile",
          component: CompanyProfile,
          meta: {
            allowedRoles: [1, 3],
          }
        },
        {
          path: "/booking_list",
          name: "Booking List",
          component: MyBooking,
        },
        {
          path: "/book",
          name: "New Booking",
          component: BookNew,
        },
        {
          path: "/book/:book_id",
          name: "Edit Booking",
          component: BookNew,
        },
        {
          path: "/email_template",
          name: "Email Template",
          component: EmailTemplate,
          meta: {
            allowedRoles: [1, 3],
          }
        },
        {
          path: "/user_list",
          name: "User List",
          component: UserList,
        },
        {
          path: "/popular_address",
          name: "Popular Address Management",
          component: PopularAddress,
          meta: {
            allowedRoles: [1, 3],
          }
        },
        {
          path: "/swop_vehicle",
          name: "Swap Vehicle",
          component: SwopVehicle,
          meta: {
            allowedRoles: [1, 3, 5],
          }
        },
        {
          path: "/swop_vehicle/:vehicle_id/:start/:end",
          name: "Swap Vehicle",
          component: SwopVehicle,
          meta: {
            allowedRoles: [1, 3, 5],
          }
        },
        {
          path: "/asset_manager",
          name: "Asset Manager",
          component: AssetManager,
          meta: {
            allowedRoles: [1, 3],
          },
        },
        {
          path: "/asset_type",
          name: "Asset Type",
          component: AssetType,
          meta: {
            allowedRoles: [1, 3],
          },
        },
        {
          path: "/asset_group",
          name: "Asset Group",
          component: AssetGroup,
          meta: {
            allowedRoles: [1, 3],
          },
        },
        {
          path: "/vehicle_service",
          name: "Vehicle Maintenance",
          component: VehicleMaintenance,
          meta: {
            allowedRoles: [1, 3, 5],
          },
        },
        {
          path: "/my_profile",
          name: "My Profile",
          component: MyProfile,
        },
        {
          path: "/report",
          name: "Report",
          component: Report,
          meta: {
            allowedRoles: [1, 3],
          },
        },
        {
          path: "/reports",
          name: "Reports",
          component: ReportsPage,
          meta: {
            allowedRoles: [1, 3],
          },
        },
        {
          path: "/company",
          name: "Company",
          component: Company,
          meta: {
            allowedRoles: [3],
          },
        },
        {
          path: "/work_order",
          name: "Work Order",
          component: WorkOrder,
          meta: {
            allowedRoles: [1, 3],
          },
        },
        {
          path: "/vehicle_accessories",
          name: "Vehicle Accessories",
          component: VehicleAccessories,
          meta: {
            allowedRoles: [1, 3],
          },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/register/:hash",
      name: "register",
      component: Register,
      props(route) {
        return route.query || {}
      }
    },
    {
      path: "/reset_password/:email_token",
      name: "reset_password",
      component: ResetPassword,
    },
    {
      path: "/message",
      name: "message",
      component: Message,
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      component: Unauthorized,
    },
  ],
});
